const host = 'https://static.paymentiq.io';

const assets = {
  logo: `${host}/logo/PaymentIQ_Logomark_Black.svg`,
  invertedLogo: `${host}/logo/PaymentIQ_Logomark_White.svg`,
  aiqLogo: `${host}/aiq.svg`,
  aiqLogoInverted: `${host}/aiq-mint.svg`,
  smallWhiteLogo: `${host}/logo/PaymentIQ_Symbol_White.svg`,
  smallLogo: `${host}/logo/PaymentIQ_Symbol_Black.svg`,
};

export default assets;
